import React from 'react';
import { logger, LogCategory } from '../../utils/logger';

interface CustomErrorPageProps {
  errorInfo?: React.ErrorInfo;
  error: Error;
  resetErrorBoundary: (args: any) => void;
}

/**
 * Custom error page for React Admin that doesn't use router hooks
 * This prevents the useLocation() error during React Admin initialization
 */
export function CustomErrorPage({ error, resetErrorBoundary, errorInfo }: CustomErrorPageProps) {
  logger.error(LogCategory.ERROR, 'CustomErrorPage rendered with error', error, 'CustomErrorPage');
  
  return (
    <div style={{ 
      padding: '20px', 
      fontFamily: 'Arial, sans-serif',
      maxWidth: '600px',
      margin: '50px auto',
      border: '1px solid #ddd',
      borderRadius: '8px',
      background: '#f9f9f9'
    }}>
      <h1 style={{ color: '#d32f2f', marginBottom: '20px' }}>
        Application Error
      </h1>
      
      <p style={{ marginBottom: '15px', color: '#666' }}>
        Something went wrong while loading the application. This might be a temporary issue.
      </p>
      
      {error && (
        <details style={{ marginBottom: '20px' }}>
          <summary style={{ cursor: 'pointer', fontWeight: 'bold', marginBottom: '10px' }}>
            Error Details
          </summary>
          <div style={{ 
            background: '#fff', 
            padding: '15px', 
            border: '1px solid #ccc', 
            borderRadius: '4px',
            fontSize: '14px',
            fontFamily: 'monospace'
          }}>
            <strong>Message:</strong> {error.message}
            <br/><br/>
            <strong>Stack Trace:</strong>
            <pre style={{ whiteSpace: 'pre-wrap', fontSize: '12px', marginTop: '10px' }}>
              {error.stack}
            </pre>
            
            {errorInfo && (
              <>
                <br/>
                <strong>Component Stack:</strong>
                <pre style={{ whiteSpace: 'pre-wrap', fontSize: '12px', marginTop: '10px' }}>
                  {errorInfo.componentStack}
                </pre>
              </>
            )}
          </div>
        </details>
      )}
      
      <div style={{ display: 'flex', gap: '10px' }}>
        <button 
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 20px',
            background: '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Reload Page
        </button>
        
        {resetErrorBoundary && (
          <button 
            onClick={resetErrorBoundary}
            style={{
              padding: '10px 20px',
              background: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Reset Application
          </button>
        )}
      </div>
      
      <p style={{ marginTop: '20px', fontSize: '12px', color: '#888' }}>
        If this problem persists, please check the browser console for more details.
      </p>
    </div>
  );
}